export const aciExpand = {
    iconName: 'expand',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M15.33 3.009a.416.416 0 00-.27.149c-.219.242-.15.598.146.757l.078.042 2.039.005 2.038.005-3.037 3.04c-3.353 3.355-3.115 3.099-3.094 3.332.013.136.05.211.15.31.138.133.369.17.538.086.035-.018 1.427-1.395 3.094-3.06l3.03-3.028.005 2.039.005 2.038.041.077a.54.54 0 00.227.226.542.542 0 00.424 0 .55.55 0 00.236-.272c.022-.078.028-5.342.007-5.42a.52.52 0 00-.354-.325c-.1-.023-5.167-.024-5.303-.001zM10.095 13.28c-.078.037-.665.616-3.112 3.064L3.967 19.36l-.01-2.034c-.01-2.274.002-2.092-.145-2.244a.413.413 0 00-.304-.14.461.461 0 00-.385.153c-.13.145-.122-.066-.123 2.876 0 2.572 0 2.676.035 2.754a.514.514 0 00.247.247c.077.034.188.036 2.738.035 1.462 0 2.68-.006 2.706-.013a.516.516 0 00.29-.243.49.49 0 00-.224-.654c-.074-.037-.133-.038-2.115-.043L4.64 20.05l3.027-3.03c1.666-1.666 3.043-3.059 3.06-3.094a.486.486 0 00-.217-.639.448.448 0 00-.414-.007z',
                fill: 'currentColor',
            },
        },
    },
};
